import { Box } from "@mui/material";

export const CITYSCAPE_HEIGHT = { xs: 320, sm: 380, md: 420 };

export default function CityscapeBackdrop() {
    return (
        <Box
            aria-hidden
            sx={{
                position: "absolute",
                left: 0,
                right: 0,
                top: { xs: 0, md: "auto" },
                bottom: { xs: "auto", md: 0 },
                width: "100%",
                height: CITYSCAPE_HEIGHT,
                pointerEvents: "none",
                zIndex: 0,
                backgroundImage: "url(/textures/cityscape.webp)",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center bottom",
                backgroundSize: { xs: "cover", md: "contain" },
                // The tint IS this filter — the artwork is inverted and hue-rotated into
                // the teal. A second, mask-based tint path keyed on theme.custom.cityscapeColor
                // used to live here; it was the last hook of the removed `kalle` brand
                // switcher, nothing could set it, and it had therefore never rendered.
                opacity: 0.32,
                filter: "invert(1) hue-rotate(180deg)",
            }}
        />
    );
}
